/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R5Inputs */



/**
* | output |
* | --- |
* | "R5 Fifth seat twice" |
*
* @param {Rounds_R5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r5 = /** @type {((inputs?: Rounds_R5Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R5Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R5 Cinquième siège deux fois")
	if (locale === "es") return /** @type {LocalizedString} */ ("R5 Quinto asiento dos veces")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R5 Quinta posição duas vezes")
	if (locale === "it") return /** @type {LocalizedString} */ ("R5 Quinto posto due volte")
	return /** @type {LocalizedString} */ ("R5 Fifth seat twice")
});